import { render, staticRenderFns } from "./anuncioImagem.vue?vue&type=template&id=b6ed038e"
import script from "./anuncioImagem.vue?vue&type=script&lang=js"
export * from "./anuncioImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports